var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.mergedSettings.adType)?_c('div',{staticClass:"block-type-26"},[_c(_vm.mergedSettings.component,{tag:"component",style:(_vm.isMobileView ? _vm.styleMobile : _vm.style),attrs:{"ad-type":_vm.mergedSettings.adType,"settings":{ ..._vm.mergedSettings.data, adBlockFallback: _vm.adBlockFallback }}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }